<script setup>
import {ref, onMounted, watch} from 'vue';
const props = defineProps(['id', 'content', 'answer']);
const solvedTips = ref('');
const detailClass = ref('');
function solved() {
  solvedTips.value = '太棒了，很高兴能解决您的问题！';
  detailClass.value = 'good';
}
function unsolved() {
  solvedTips.value = '很抱歉没有解决您的问题，欢迎您反馈意见！';
  detailClass.value = 'bad';
}
watch(() => props.id, (newValue) => {
  solvedTips.value = '';
});
</script>

<template>
  <div class="detail">
    <p class="title">{{props.content}}</p>
    <hr class="hr"/>
    <p class="content" v-html="props.answer"></p>
    <div class="hr-wording">
      <div class="hr-short"></div>
      <p class="wording">是否有解决您的问题？</p>
      <div class="hr-short"></div>
    </div>
    <div class="buttons" v-if="!solvedTips">
      <button class="icon-button" @click="solved">
        <img src="../assets/good.png" alt="" class="icon">
        已解决
      </button>
      <button class="icon-button" @click="unsolved">
        <img src="../assets/bad.png" alt="" class="icon">
        未解决
      </button>
    </div>
    <div v-else>
      <p :class="['solved-tips', detailClass]">{{solvedTips}}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
.detail {
  margin: 0 24 * $px 24 * $px 24 * $px;
  background-color: #fff;
  border-radius: 14 * $px;
  .title {
    font-size: 32 * $px;
    font-weight: bold;
    line-height: 45 * $px;
    padding: 36 * $px;
    margin: 0;
  }
  .hr {
    margin: 0 36 * $px;
    border: 1*$px solid rgba(227, 227, 227, 1);
  }
  .content {
    font-size: 28 * $px;
    line-height: 42 * $px;
    padding: 0 36 * $px;
    margin-top: 36*$px;
  }
  .hr-wording {
    //position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 24 * $px 0;
    .hr-short {
      //border: 1*$px solid rgba(227, 227, 227, 1);
      //position: absolute;
      //width: 60%;
      flex: 1;
      max-width: 25%; // 控制横线的最大宽度
      height: 1 * $px;
      background: rgba(227, 227, 227, 1);

      &:first-child {
        margin-left: 20%; // 控制左侧空白
      }

      &:last-child {
        margin-right: 20%; // 控制右侧空白
      }
    }
    .wording {
      font-size: 24 * $px;
      line-height: 33.6 * $px;
      color: rgba(136, 136, 136, 1);
      padding: 0 10*$px;
      background-color: #fff;
      //position: relative;
      text-align: center;
    }
  }
  .buttons {
    display: flex;
    justify-content: center;
    height: 130 * $px;
    .icon-button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      margin: 0 16 * $px;
      border: 2*$px solid rgba(221, 221, 221, 1);
      border-radius: 36 * $px;
      font-size: 24 * $px;
      line-height: 33.6 * $px;
      background: #fff;
      width: 299 * $px;
      height: 74 * $px;
      color: #333333;

      .icon {
        width: 32 * $px;
        height: 32 * $px;
        margin-right: 10*$px;
      }
    }
  }
  .solved-tips {
    display: flex;
    justify-content: center;
    font-size: 28 * $px;
    height: 122 * $px;
  }
  .good {
    color: rgba(75, 106, 255, 1);
  }
  .bad {
    color: rgba(255, 163, 75, 1);
  }
}
</style>
